/// <amd-module name="Search/Package/Constants" />

export namespace FilterKeys {
    export const FeedFiltersKey: string = "Feeds";
    export const ViewFiltersKey: string = "View";
    export const TypeFiltersKey: string = "ProtocolType";
}

export namespace CustomerIntelligenceConstants {
    export const EntityName = "package";
    export const FiltersUpdated = "FiltersUpdated";
    export const FilterResetClicked = "FilterResetClicked";
    export const SearchInNewTab = "SearchInNewTab";
    export const SearchStarted = "SearchStarted";
    export const ResultsLoaded = "ResultsLoaded";
    export const LaunchPoint = "LaunchPoint";
    export const FetchMoreResultsStarted = "FetchMoreResultsStarted";
    export const TTIScenarioName = "PackageSearchTTIScenario";
    export const TabSwitchScenarioName = "PackageSearchTabSwitchScenario";
    export const SubsequentSearchScenarioName = "PackageSearchTTIScenario";
    export const ZeroData = "ZeroData";
    export const FeedbackMailLinkClicked = "FeedbackMailLinkClicked";
    export const AccountButtonClicked = "AccountButtonClicked";
    export const SearchTextRemoved = "SearchTextRemoved";
    export const FeedbackLinkClicked = "FeedbackLinkClicked";
    export const NotificationBanner = "NotificationBanner";
}

export namespace FeatureFlagConstants {
    export const InfiniteScroll = "WebAccess.Search.Package.InfiniteScroll";
}

export namespace IndexingErrorCodeConstants {
    export const AccountIsBeingIndexed = "AccountIsBeingIndexed";
    export const AccountIsBeingReindexed = "AccountIsBeingReindexed";
    export const AccountIsBeingOnboarded = "AccountIsBeingOnboarded";
}

export const EntityTypeUrlParam: string = "package";
export const CodexFeedbackMailToLinkFormat: string =
    "https://developercommunity.visualstudio.com/report?space=21&version=NONE&azActivityId={0}";
export const PackageSearchTakeResults = 50;
export const PackageSearchInfiniteScrollTakeResults = 25;
export const PackageSearchMaxTakeResults = 1000;
export const PackageSearchLoadMoreTakeResults = 20;
export const LearnMoreLink: string = "https://go.microsoft.com/fwlink/?linkid=2088433";
export const AllViewItemId = "All";